/**
 * Display steps for the AI analyse progress stepper (Australian English).
 * Maps to backend stages in timesheet_anomaly_progress.py.
 */
export const AI_ANALYSE_DISPLAY_STAGES = [
  { key: "gathering_data", label: "Gathering shift data" },
  { key: "preparing_context", label: "Preparing secure context" },
  { key: "ai_analyse", label: "Running AI analyse" },
  { key: "applying_checks", label: "Applying NDIS checks" },
  { key: "saving_report", label: "Saving analyse report" },
];

export const resolveActiveStageIndex = (stageKey) => {
  if (!stageKey) return 0;
  const idx = AI_ANALYSE_DISPLAY_STAGES.findIndex((s) => s.key === stageKey);
  if (idx >= 0) return idx;
  if (stageKey === "validating_access" || stageKey === "starting") return 0;
  if (stageKey === "finalising" || stageKey === "complete") {
    return AI_ANALYSE_DISPLAY_STAGES.length;
  }
  return 0;
};

export const INITIAL_AI_PROGRESS_STATE = {
  open: false,
  percent: 4,
  stage: "starting",
  label: "Starting AI analyse",
  timesheetCompleted: 0,
  timesheetIndex: 0,
  timesheetTotal: 0,
  timesheetId: null,
  error: null,
  errorCode: null,
  status: null,
};

/**
 * Merge a streamed progress event into modal state.
 * Parallel workers emit out of order — completed_count is monotonic;
 * never take the last worker's timesheet_index as "X of Y".
 */
export const applyTimesheetAiProgressEvent = (
  prev,
  event,
  { nextPercent, timesheetLabel } = {}
) => {
  const incomingCompleted = Number(event?.completed_count);
  const hasCompleted = Number.isFinite(incomingCompleted);
  const timesheetCompleted = hasCompleted
    ? Math.max(prev.timesheetCompleted || 0, incomingCompleted)
    : prev.timesheetCompleted || 0;

  return {
    ...prev,
    percent: Math.max(prev.percent || 0, nextPercent ?? 0),
    stage: event?.stage ?? prev.stage,
    label: event?.label ?? prev.label,
    timesheetCompleted,
    timesheetIndex: timesheetCompleted,
    timesheetTotal: event?.timesheet_total ?? prev.timesheetTotal,
    timesheetId: event?.timesheet_id ?? prev.timesheetId,
    timesheetLabel: timesheetLabel || prev.timesheetLabel,
    error: null,
    errorCode: null,
    status: null,
  };
};
